// @flow
import * as React from 'react';
import ReactGA from 'react-ga';

type Props = { location: Location };

// HOC that should live somewhere under ReactRouter
// Provides page tracking only
// Requires that ReactGA.initialize has been alreay called otherwise
// nothing will get sent/tracked.
export function withTracker(WrappedComponent: React.ComponentType<any>) {
    const trackPage = page => {
        ReactGA.pageview(page);
    };

    return class extends React.Component<Props, void> {
        componentDidMount() {
            const page = this.props.location.pathname;
            trackPage(page);
        }

        componentWillReceiveProps(nextProps: Props) {
            const currentPage = this.props.location.pathname;
            const nextPage = nextProps.location.pathname;

            if (currentPage !== nextPage) {
                ReactGA.pageview(nextPage);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/universal-analytics/tracker.js